import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../../../types/store';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { getFolderDeviationsStreamId } from '../../../../../streams/folderDeviations';
import { Props } from './LeaderboardWrapper';
import {
  getGallectionSectionType,
  getSelectedSubfolder,
} from '../../../../../selectors/gallectionSection';
import { getPagingMode } from '@wix/da-shared-react/pkg/publicSession/selectors';

type StateProps = Pick<Props, 'hasMore' | 'pagingMode'>;
type DispatchProps = Pick<Props, never>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  { folderId }
) => {
  const gallectionType = getGallectionSectionType(state);
  const selectedSubfolder = getSelectedSubfolder(state);

  let streamId;
  let subfolder;

  if (selectedSubfolder && selectedSubfolder.parentId === folderId) {
    subfolder = selectedSubfolder;
    streamId = getFolderDeviationsStreamId(gallectionType, subfolder.folderId);
  } else {
    streamId = getFolderDeviationsStreamId(gallectionType, folderId);
  }

  return {
    pagingMode: getPagingMode(state),
    hasMore: streamSelectors.hasMore(state, streamId) !== false,
  };
};

const mapDispatchToProps = dispatch => ({});

export default connect<StateProps, DispatchProps, OwnProps, AppState>(
  mapStateToProps,
  mapDispatchToProps
);
